import { IOpData, IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from './enums'
import { OpDataList } from '../util/op-data-list'
import { OpDataType } from '../core/op-data-type'
import { DataProvider } from '../../helpers/data-provider'
import * as moment from 'moment'

export class OpBaseData implements IOpData {
    public idData: number
    public idDataType: number
    public indexNBR: number
    public opState: Enums.OpChangeState
    public value: any
    public statusColor: number
    
    private _dataType: OpDataType
    public get dataType(): OpDataType {
        return this._dataType
    }
    public set dataType(value: OpDataType) {
        this._dataType = value
        this.idDataType = value ? value.idDataType : null
    }

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idData = opObj.ID_DATA ? opObj.ID_DATA : 0
            this.indexNBR = opObj.INDEX_NBR
            this.opState = opObj.OpState
            if (typeof opObj.VALUE == 'string' && opObj.VALUE.indexOf('/Date(') > -1) {
                this.value = new Date(moment.parseZone(opObj.VALUE).format('LLL'))
            } else {
                this.value = opObj.VALUE
            }
            this.statusColor = opObj.StatusColor ? opObj.StatusColor : null

            this.dataType = opObj._DataType ? new OpDataType(opObj._DataType) : null
            this.idDataType = opObj.ID_DATA_TYPE
        }
    }

    public toJSON(compressed: boolean = false): any {
        var value = this.value
        if (value && typeof value === 'object' && typeof value.getTime === 'function') {
            value = moment(value).format('YYYY-MM-DD HH:mm:ss.SSS')
        }
        return {
            ID_DATA: this.idData,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNBR,
            OpState: this.opState,
            VALUE: value
        }
    }
}

export abstract class OpBase<T extends OpBaseData> implements IReferenceType, IOpChangeState, IJsonSerializable {
    public dataList: OpDataList<IOpData> = new OpDataList()
    public dynamicValues: { Key: string, Value: any }[] = []
    public opState: Enums.OpChangeState = Enums.OpChangeState.New

    constructor(opObj: any, opBaseData: { new (obj): T }) {
        this.fromJSON(opObj)
    }

    public abstract getReferenceType(): Enums.ReferenceType
    public abstract getReferenceKey(): number
    public abstract getReferenceValue(): any

    public abstract toString(): string

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (opObj.DataList) {
                this.dataList.push(...opObj.DataList.map(data => new OpBaseData(data)))
            }
            this.dynamicValues = opObj.dynamicValues
            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            DataList: this.dataList.ToJSON(),//.map(d => d.toJSON()),
            OpState: this.opState
        }
    }
}